import { useState, useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { Alert } from 'react-bootstrap'
import Sidebar from './Sidebar'
import Header from './Header'
import { useAuthStore } from '../../store/authStore'

export default function Layout() {
  const { user, selectedTenant } = useAuthStore()
  const location = useLocation()
  const isSuperAdmin = user?.role === 'super_admin'
  const [sidebarOpen, setSidebarOpen] = useState(false)

  // Close sidebar on route change (mobile)
  useEffect(() => {
    setSidebarOpen(false)
  }, [location.pathname])

  // Pages that don't require tenant selection
  const globalPages = ['/', '/tenants', '/users', '/settings']
  const isGlobalPage = globalPages.includes(location.pathname)

  const showTenantWarning = isSuperAdmin && !selectedTenant && !isGlobalPage

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen)
  const closeSidebar = () => setSidebarOpen(false)

  return (
    <div className="app-layout">
      {/* Overlay for mobile */}
      {sidebarOpen && (
        <div
          className="sidebar-overlay"
          onClick={closeSidebar}
        />
      )}
      <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />
      <div className="main-content">
        <Header onToggleSidebar={toggleSidebar} />
        <div className="content">
          {showTenantWarning ? (
            <Alert variant="warning" className="mb-3 d-flex align-items-center">
              <i className="bi bi-exclamation-triangle-fill me-2 fs-5"></i>
              <div>
                <strong>Kein Mandant ausgewählt!</strong> Bitte wählen Sie oben im Header einen Mandanten aus,
                um dessen Daten zu bearbeiten.
              </div>
            </Alert>
          ) : (
            <Outlet />
          )}
        </div>
      </div>
    </div>
  )
}
